import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_BATCH_BY_ID = 'GET_BATCH_BY_ID';
export const GET_BATCH_BY_ID_SUCCESS = 'GET_BATCH_BY_ID_SUCCESS';
export const GET_BATCH_BY_ID_FAIL = 'GET_BATCH_BY_ID_FAIL';
export const GET_BATCH_BY_ID_RESET = 'GET_BATCH_BY_ID_RESET';

export const getBatchById = (params) => ({
  type: GET_BATCH_BY_ID,
  params,
});

export const getBatchByIdSuccess = (response) => ({
  type: GET_BATCH_BY_ID_SUCCESS,
  response,
});

export const getBatchByIdFail = (response) => ({
  type: GET_BATCH_BY_ID_FAIL,
  response,
});

export const getBatchByIdReset = () => ({
  type: GET_BATCH_BY_ID_RESET,
});

export const getBatchByIdApi = (data) => {
  return (dispatch) => {
    dispatch(getBatchById());
    const { id, page = 1, limit = 10, search = '',status = '' } = data;
    
    axios
      .get(`${config.api.base_url}/batch/${id}`, {
        params: {
          page,
          limit,
          search,
          status
        },
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getBatchByIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getBatchByIdFail(error.message));
      });
  };
}; 